import { Observable } from 'rxjs'
import { EnrollmentElectionType } from '../models/enrollment-election-type'
import { PlanList } from '../models/plan-list'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { EnrollmentDetail } from '../models/en-details'
import { SubmitEnrollmentDataResponse } from '../models/submit-enrollment-data-response'
import { BeneficiarySoaDetail } from '../models/view-soa-model'
import { SearchInsertModel } from '../models/search-soa-model'
import { SaveEmailModel } from '../models/saveEmailModel'
//import { SavePharmacyEmailModel } from '../models/save-pharmacy-email-model'
import { EnrollmentPageContent } from '../models/enrollment-page-content-model'
import { EnrollmentData } from '../models/enrollment-data'
import { EnrollmentField, EnrollmentFieldEapp, EnrollmentFieldCodes } from '../models/enrollment-field'
import { SendEmailModel } from '../models/SendEmailModel'
import { EnrollmentSettingModel } from '../models/EnrollmentSettingModel'
import { EappUpdateStatus } from '../models/eapp-status-model'
import { ElectionPeriods } from '../models/election-periods'
import { ValidAgent } from '../models/valid-agent'
import { ExportSOAModel } from '../../electronic-soa/models/export-soa-model'
import { stcobModel } from '../models/stcob-model'
import { ExportHistoryModel } from '../models/export-history-model'
import { OrgFeatureSettingValue } from '../../bak-questions/models/bakquestions'
import { PreEnrollmentCallLogDetails } from '../models/PreEnrollmentCallLogDetails'
import { DispositionLookUP } from '../../call-start/models/disposition-lookup'
import { CallLogLookUp } from '../../call-start/models/call-log-lookup'
import { IPadHistory } from '../models/ipadhistory-model'
import { IPadPDF } from '../models/ipadhistory-model'
import { EnrollmentHeader } from '../models/EnrollmentHeader'
import { GetEnrollmentRequest } from '../models/GetEnrollmentDataRequest'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../models/get-enrollment-data-response'
import { CurrentUser } from '../../../app/common/models/current-user'
import { PhonePage3Data } from '../models/phone-page3-data'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { GroupPlanFilterData } from '../models/GroupPlanFilterData'
import { ElectionModel } from '../models/election-model'
import { ValidatedSelectOptionModel as ReasonCode } from '../../validations/validated-dropdown.component'
import { EthnicityData } from '../models/ethnicity-data'
import { RaceData } from '../models/race-data'
import { GenderPref } from '../models/gender-pref'
import { RelationshipToEnrollee } from '../models/relationshipToEnrollee'

export abstract class EnrollmentGateway {
    public _backClicked: boolean
    abstract getEnrollmentElectionTypes(orgID: string, planYear: string): Observable<EnrollmentElectionType[]>
    abstract getElectionDetails(confNumber: string): Observable<EnrollmentElectionType[]>
    abstract getPlanList(orgId: number, planyear: string): Observable<PlanList[]>
    abstract setEnrollmentViewModel(value: EnrollmentViewModel)
    abstract getEnrollmentViewModel(): EnrollmentViewModel
    //  abstract submitEnrollment(orgID: number): Observable<EnrollmentElectionType[]>
    // abstract SendEmail(orgID: number): Observable<any>
    abstract SendEmail(mailTo: string, clientName: string, refGUID: string, planYear: string): Observable<any>
    // abstract SendPharmacyEmail(mailTo: string, FirstName: string, LastName: string): Observable<any>

    abstract CheckLicense(state: string): Observable<any>

    abstract SubmitEnrollmentData(submitEnrollmentData: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse>
    abstract SendEmailUser(): Observable<any>
    abstract saveEnrollmentEmail(saveEmailModel: SaveEmailModel, planYear: number): Observable<string>
    // abstract savePharmacyEmail(saveEmailModel: SavePharmacyEmailModel): Observable<SavePharmacyEmailModel>

    abstract searcheAppHistoryData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]>
    abstract searchPWeAppHistoryData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]>

    abstract loadEAppHistoryData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]>
    abstract loadPWEAppHistoryData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]>

    abstract loadBSOADataSync(searchsoadetail: SearchInsertModel): BeneficiarySoaDetail[]

    abstract downloadPDF(beneficiaryPdf: string): Observable<any>
    abstract GetEnrollmentPageContent(ParentName: string, SectionName: string): Observable<EnrollmentPageContent[]>
    abstract isValidAgent(userProfileName: string): Observable<any>
    abstract isExternalValid(userProfileName: string): Observable<any>
    abstract isSingleGroupValid(userProfileName: string): Observable<any>
    abstract getCUIDByUserName(userProfileName: string): Observable<string>
    abstract UpdateEnrollmentData(submitEnrollmentData: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse>
    abstract generatePDF(enrollmentData: EnrollmentViewModel, insCompanyName: string, planyear: number): Observable<any>
    abstract printEnrollmentPDF(enrollmentData: EnrollmentViewModel, insCompanyName: string): Observable<any>

    abstract getEnrollmentAppDetails(guid: string): Observable<EnrollmentFieldEapp[]>
    abstract SubmitElectronicEnrollmentData(submitEnrollmentData: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse>
    abstract UpdateElectronicEnrollmentData(submitEnrollmentData: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse>
    // TODO: implement this to handle EnrollmentData
    // abstract SaveEnrollmentData(enrollmentData: EnrollmentData): Observable<SubmitEnrollmentDataResponse>

    abstract getEnrollmentSetting(planYear: string, currentuser: CurrentUser): Observable<EnrollmentSettingModel>

    abstract updateEAppStatus(eappUpdateStatus: EappUpdateStatus): Observable<EappUpdateStatus>
    abstract SendAgentEmail(mailTo: string, agentName: string, agentId: number, beneName: string): Observable<any>
    abstract getElectionPeriods(planYear: string, isDataEntryOrExternal: number): Observable<ElectionPeriods[]>
    abstract getEappDetails(uniqueLink: string): Observable<EappUpdateStatus[]>

    abstract getEAppHistoryForExport(searchsoadetail: SearchInsertModel): Observable<ExportHistoryModel[]>
    abstract getPWEAppHistoryForExport(searchsoadetail: SearchInsertModel): Observable<ExportHistoryModel[]>

    abstract getStcobDetails(orgId: number): Observable<stcobModel[]>
    abstract getStcobDetailsByState(orgId: number, stateCd: string): Observable<stcobModel[]>
    abstract getGroupPlanList(groupPlanFilterData: GroupPlanFilterData): Observable<stcobModel[]>
    abstract getStcobDetail(orgId: number, planShortName: string, stateCd: string): Observable<stcobModel>

    abstract validateZip(PermanentStateCode: string, PermanentZipCode: string, MailingStateCode: string, MailingZipCode: string): Observable<string[]>
    abstract validateZipForAll(
        PermanentStateCode: string,
        PermanentZipCode: string,
        MailingStateCode: string,
        MailingZipCode: string,
        AuthStateCode: string,
        AuthZipCode: string
    ): Observable<string[]>

    abstract getOrgAppFeatureSettingValues(orgId: number, featureName: string, settingName: string): Observable<OrgFeatureSettingValue[]>
    abstract GetPreEnrollmentBeneficiaryDtl(calllogId: number): Observable<PreEnrollmentCallLogDetails>
    abstract getDispositionByPlanYear(planYear: string): Observable<DispositionLookUP[]>
    abstract GetPhoneEnrollmentAcccessCheck(OrgId: number, RoleId: string): Observable<boolean>
    abstract EndEnrollmentCall(preEnrollmentCallLogDetails: PreEnrollmentCallLogDetails): Observable<number>
    abstract SaveCallErollmentLog(
        CallLogId: number,
        EnrollmentStartDate: string,
        CallDispositionID: number,
        IsBeneficiary: number
    ): Observable<number>
    abstract SaveCallLogClientLookup(callLogLookUp: CallLogLookUp): Observable<number>
    abstract CheckParentOragnizationId(OrgId: number): Observable<number>
    abstract getPreEnrollmentCallLogDetails(): PreEnrollmentCallLogDetails
    abstract setPreEnrollmentCallLogDetails(preEnrollmentCallLogDetails: PreEnrollmentCallLogDetails)
    abstract SendEmailOnConfirmation(planName: string): Observable<any>
    abstract validateZipCode(PermanentStateCode: string, PermanentZipCode: string): Observable<string>

    abstract GetAllIPadHistorySync(FmoModel: IPadHistory): IPadHistory[]

    abstract GetAllIPadHistory(FmoModel: IPadHistory): Observable<IPadHistory[]>
    abstract GetAllPWIPadHistory(FmoModel: IPadHistory): Observable<IPadHistory[]>

    abstract GetAllIPadExcel(FmoModel: IPadHistory): Observable<IPadHistory[]>
    abstract downloadPDFIPad(FmoModel: IPadPDF): Observable<any>
    abstract getPDFFileName(ConfirmationNumber: string, PreEnrollmentId: number): Observable<IPadPDF[]>
    abstract getEnrollmentHeader(enrollmentHeader: EnrollmentHeader): Observable<EnrollmentField[]>

    abstract getEnrollmentDetail(getEnrollmentRequest: GetEnrollmentRequest): Observable<GetEnrollmentDataResponse>

    abstract getEnrollmentDetailByEnrollmentID(enrollmentId: number): Observable<GetEnrollmentDataByID>

    abstract downloadIPadLoginHistoryExcel(): Observable<any>
    abstract getOrgIdByUserName(userProfileName: string): Observable<string>

    abstract getPhonePage3Data(): Observable<PhonePage3Data>
    abstract GetAllParentStatesForOrg(InsuranceCoID: number): Observable<ValidatedSelectOptionModel[]>
    abstract streamPDF(file: string): Observable<any>
    abstract getEGWPUserProfileName(): Observable<any>
    abstract getPlanPremium(OrgID: number, PlanYear: string, Planname: string, StateAbbr: string): Observable<string>

    abstract LoadAdobeScript()
    abstract getEnrollmentDataByKey(enrollmentKey: string): Observable<GetEnrollmentDataResponse>
    abstract getEnrollmentViewModelByKey(model: GetEnrollmentDataResponse): EnrollmentViewModel
    //  abstract getElectionFormData(planyear: string, isDataEntryOrExternal: number): Observable<ElectionModel>
    abstract getElectionFormData(planyear: string, isDataEntryOrExternal: number, appDt: string, reportFlag: boolean): Observable<ElectionModel>
    abstract getDisEnrollmentReasonCodes(): Observable<ReasonCode[]>
    abstract getPaperlessSetting(enrollmentChannel: string): Observable<boolean>
    abstract getEmailsSetting(planYear: number, SelectedPlanyear: number): Observable<boolean>

    abstract generatePDFSearch(planYear: number, enrollmentData: EnrollmentViewModel, insCompanyName: string): Observable<any>

    abstract getCurrentDate(): Observable<any>

    abstract CheckDuplicateEnrollment(submitEnrollmentData: EnrollmentViewModel): Observable<string[]>

    abstract getRaceData(): Observable<RaceData[]>
    abstract getEthnicityData(): Observable<EthnicityData[]>
    abstract getGenderData(genderPref: string): Observable<GenderPref[]>
    abstract getRelationshipToEnrolleeData(): Observable<RelationshipToEnrollee[]>
}
